import { Box, Divider, LinearProgress, Tooltip, Typography } from "@mui/material";

import { CabinPricesItem, FlightItem, TransferOption, CabinsType } from "@/typings";
import { getSeatsText } from "@/utils";
import { CabinsColors, CabinNameMap } from "@/constants/config";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

interface CabinInfoProps {
  data: FlightItem;
  partialDisplay: boolean;
}

const CabinInfoPc = (props: CabinInfoProps) => {
  const { cabin_prices } = props.data;
  const { partialDisplay } = props;


  const minPts = (data: CabinPricesItem) => {
    return data.miles // Use miles of airline instead of transfer options

    if (data.transfer_options && data.transfer_options.length == 0) {
      return data.miles
    }

    return Math.min(...(data.transfer_options?.map((ele: TransferOption) => ele.points) || [data.miles]));
  };

  const formatTime = (minutes: number) => {
    if (minutes > 60) {
      return `${Math.floor(minutes / 60)}hr ${minutes % 60}min`;
    } else {
      return `${minutes} min`;
    }
  };

  const renderCabinItem = (cabinItem: CabinPricesItem, type: CabinsType) => {
    if (!cabinItem) {
      return "-";
    }

    const seatsText = getSeatsText(cabinItem.seats);
    const totalDuration = cabinItem.segments?.reduce((acc, segment) => acc + segment.duration, 0) || 0;
    if (cabinItem.segments) {
      cabinItem.segments.forEach((segment) => {
        segment.percentage = Math.round((segment.duration / totalDuration) * 100);
      });
    }

    // cabinItem.cash_price = 99999;
    const cashPrice = cabinItem.cash_price > 0 ? `Cash $${cabinItem.cash_price.toLocaleString()}` : null;

    return (
      <div className="text-center">
        <div className="flex flex-col mt-[6px]">
          <Typography fontSize={13} className={seatsText ? "visible" : "invisible"} style={{ marginBottom: "0px" }}>{seatsText || "0"}</Typography>
          {partialDisplay ? (
            <Typography fontSize={24} className="blur-sm select-none">
              IIII K
            </Typography>
          ) : (
            <Typography fontSize={24}>
              {(Math.ceil((minPts(cabinItem) / 1000) * 100) / 100)} K
            </Typography>
          )}
          {cabinItem.tax > 0 && <Typography fontSize={16} style={{ marginTop: "-5px" }}>+ ${cabinItem.tax.toLocaleString()}</Typography>}
        </div>

        <Tooltip title={
          <div className="flex flex-col">
            {cabinItem.segments && cabinItem.segments.map((segment, index) => {
              return <div key={index} >
                <div>✈️ <strong>{segment.cabin}</strong> ({segment.departure}-{segment.arrival}): {formatTime(segment.duration)} - {segment.percentage}%</div>
                {segment.layover > 0 && <div className="text-center my-[3px]"> 🕒 Layover: {formatTime(segment.layover)}</div>}
              </div>
            })}
          </div>
        }>
          <div className="flex flex-col mt-[3px]">
            <Typography
              fontSize={13}
              className={(type === "Economy" || cabinItem.premium_cabin_percentage == 0 || !cabinItem.premium_cabin_percentage) ? "invisible" : "visible"}
            >
              {Math.round(cabinItem.premium_cabin_percentage)}% Premium
            </Typography>
            {type !== "Economy" && cabinItem.segments ? <div className="flex space-x-[3px] py-[3px] w-[90%] mx-auto">
              {cabinItem.segments.map((item, index) => (
                <div
                  key={index}
                  style={{
                    flex: Math.round((item.duration / totalDuration) * 100),
                    height: 2.5,
                    backgroundColor: CabinsColors[CabinNameMap[item.cabin as CabinsType] as keyof typeof CabinsColors] || CabinsColors.economy,
                  }}
                  className="flex-1 rounded-sm w-full"
                />
              ))}
            </div> : <div className="flex space-x-[3px] py-[3px] w-[80%] mx-auto">
              <div className="flex-1 rounded-sm w-full" />
            </div>}
          </div>
        </Tooltip>
        {cashPrice &&
          <Typography variant="body2" color="textSecondary" fontSize={13} className="pt-[2px] pl-[2px]">
            <MonetizationOnOutlinedIcon color="primary" sx={{ fontSize: 15, mb: -0.35, mr: 0.2 }} />
            {cashPrice}
          </Typography>
        }
      </div>
    );
  };

  return (
    <Box className="flex flex-1 space-x-1">
      <Divider orientation="vertical" />
      <div className="flex-1 min-h-[150px] flex items-center justify-center">
        {renderCabinItem(cabin_prices.Economy, "Economy")}
      </div>
      <Divider orientation="vertical" />
      <div className="flex-1 min-h-[150px] flex items-center justify-center">
        {renderCabinItem(cabin_prices["Premium Economy"], "Premium Economy")}
      </div>
      <Divider orientation="vertical" />
      <div className="flex-1 min-h-[150px] flex items-center justify-center">
        {renderCabinItem(cabin_prices.Business, "Business")}
      </div>
      <Divider orientation="vertical" />
      <div className="flex-1 min-h-[150px] flex items-center justify-center">
        {renderCabinItem(cabin_prices.First, "First")}
      </div>
      <Divider orientation="vertical" />
    </Box>
  );
};

export default CabinInfoPc;
